// @ts-check

import { useState } from "react";
import { useAppBridge } from "@shopify/app-bridge-react";
import { BlockStack, Label, Modal } from "@shopify/polaris";
import { useQueryClient } from "@tanstack/react-query";

import { endOfDay, startOfDay, subDays } from "date-fns";

import { DateRangePicker } from "components/DateRangePicker/DateRangePicker";

export const CreateUtmSetExportModal = ({
  open,
  setOpen,
}) => {
  const shopify = useAppBridge();
  const queryClient = useQueryClient();

  const [createExportLoading, setCreateExportLoading] = useState(false);
  const [dates, setDates] = useState({
    start: startOfDay(subDays(new Date(), 6)),
    end: endOfDay(new Date()),
  });

  const createNewExport = async () => {
    setCreateExportLoading(true);

    return fetch("/api/utm-set-exports", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        start_date: dates.start.toISOString(),
        end_date: dates.end.toISOString(),
        browser_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setOpen(false);
        shopify.toast.show("Export created");
        queryClient.invalidateQueries({ queryKey: ["utmSetExports"] });
      })
      .finally(() => {
        setCreateExportLoading(false);
      });
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      title="Are you sure you want to create a new UTM set export?"
      primaryAction={{
        content: "Create export",
        onAction: createNewExport,
        loading: createExportLoading,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: () => setOpen(false),
        },
      ]}
    >
      <Modal.Section>
        <BlockStack gap="300">
          <p>This will create a CSV file that will contain the complete history of your UTM sets.</p>

          <p>
            Your report will take a few minutes to generate, check back on this page later.
          </p>

          <BlockStack gap="100">
            <Label id="date-range-label">Date range</Label>
            <DateRangePicker
              dates={dates}
              onChange={setDates}
            />
          </BlockStack>
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
};
